import { render, staticRenderFns } from "./product-in-location.vue?vue&type=template&id=81334764&scoped=true"
import script from "./product-in-location.vue?vue&type=script&lang=ts"
export * from "./product-in-location.vue?vue&type=script&lang=ts"
import style0 from "./product-in-location.vue?vue&type=style&index=0&id=81334764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81334764",
  null
  
)

export default component.exports